module.exports = __webpack_public_path__ + "static/media/sq5.7a351ebc.jpg";